import { GoogleTranslateDropdown } from './GoogleTranslateDropdown'
import React = require('react')
import { features } from '../../features'

declare global {
  interface Window {
    google: any
    googleTranslateElementInit: any
  }
}

const deleteCookie = (name) => {
  var hostname = window.location.hostname
  var splitHostname = hostname.split(".")
  var baseDomain = `${splitHostname[splitHostname.length - 2]}.${splitHostname[splitHostname.length - 1]}`
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Domain=.' + baseDomain + ';'
}

export const GoogleTranslateMenuItem = (props: { className?: string; mobile?: boolean }) => {
  React.useEffect(() => {
    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({ autoDisplay: false }, 'google_translate_element')
      const languageSelectElement = document.querySelector('#\\:0\\.targetLanguage select') as HTMLSelectElement
      languageSelectElement?.classList.add('notranslate')
      languageSelectElement.id = 'google_language_selector'
      const f = features()
      const pushDatalayerTranslateAction = f.automatedTranslations != 'off' && f.automatedTranslations.pushDataLayerEvent
      languageSelectElement.addEventListener('change', function () {
        pushDatalayerTranslateAction && pushDatalayerTranslateAction(languageSelectElement.value)
        if (languageSelectElement.value == "nl" || languageSelectElement.value == "") {
          deleteCookie("googtrans");
          window.location.reload();
        }
      })
      const placeholderElement = document.getElementById('google_languages_placeholder')
      placeholderElement?.replaceWith(languageSelectElement)
    }

    const script = document.createElement('script')
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    script.async = true

    document.body.appendChild(script)
    window.googleTranslateElementInit = googleTranslateElementInit
  }, [])
  return (
    <GoogleTranslateDropdown
      mobile={props.mobile}
      wrapper={dropdown => <li className={props.className || 'utilities__menu-item'}>{dropdown}</li>}
    />
  )
}
